// Modules
import { lazy, Suspense } from 'react';
import { Navigate } from 'react-router-dom';

// UI
import { Spinner } from 'components/common/Spinner';

// Utils
import { RouteDefinition } from './types';
import { onlyCustomerAllowedMiddleware } from './middlewares/middlewares';

// Lazy loading wrapper with Suspense fallback
const LazyLoad = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={
    <div className="flex items-center justify-center w-full h-96">
      <Spinner size="lg" />
    </div>
  }>
    {children}
  </Suspense>
);

// Lazy-loaded Pages
const CustomerPortal = lazy(() => import('pages/Customer'));

// Customer routes - rendered under /customers with CustomerLayout
export const customerRoutes: RouteDefinition[] = [
  {
    enabled: true,
    index: true,
    Component: <LazyLoad><CustomerPortal /></LazyLoad>,
    middlewares: [onlyCustomerAllowedMiddleware],
  },
  // Redirect any unmatched customer paths to dashboard
  {
    enabled: true,
    path: '*',
    Component: <Navigate to="/customers" replace />,
    middlewares: [],
  },
];
